/*jshint esnext: true */
/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Lars Munkholm
 Modified by:
 Client name: Danske Regioner
 Date of creation: 9.3.2016
 */

(function ($, dis) {
	"use strict";


	dis.SocialSharing = function (objectConfiguration) {
		dis.BaseModule.call(this);

		var defaults = {
				fbAppId: "714516208727673"
			},
			configuration = $.extend(defaults, objectConfiguration),
			dom = {},
			eventHandlers,
			selfScope = this;


		eventHandlers = {
			openPopup: function (url) {
				var width = 575,
					height = 400,
					left = (selfScope.globalDOM.window.width() - width) / 2,
					top = (selfScope.globalDOM.window.height() - height) / 2,
					opts = "status=1" +
						",width=" + width +
						",height=" + height +
						",top=" + top +
						",left=" + left;

				window.open(url, 'socialsharer', opts);

				return false;
			}
		};


		function init() {
			dom.container = $(configuration.container);

			if (dom.container.length) {
				dom.facebook = dom.container.find(".facebook");
				dom.twitter = dom.container.find(".twitter");
				dom.linkedin = dom.container.find(".linkedin");


				// Share on Twitter
				//-----------------
				dom.twitter.click(function (e) {
					e.preventDefault();

					var clicked = $(this),
						section = clicked.closest("section, .article__box--quote"),
						anchor,
						link,
						text,
						shareUrl = "https://twitter.com/intent/tweet?url=",
						linkChars = 23,
						maxChars = 140 - linkChars - 1;

					if (section.hasClass("figure-box")) {
						// Get data if figure box
						//-----------------------

						// Get anchor
						anchor = section.attr("id");

						// Get title
						text = section.find("h1:first").text().trim();
					} else if (section.hasClass("article__box--quote") || section.hasClass("box-quote")) {
						// Get data if quote box
						//----------------------

						// Get anchor
						anchor = section.attr("id");

						// Get title
						text = section.find("blockquote").text().trim();

						if (text.length > maxChars) {
							text = text.substring(0, maxChars - 3) + "...";
						}
					} else if (section.hasClass("subpage article")) {
						// Get data if subpage article
						//-----------------------

						// Get anchor
						anchor = section.attr("id");
						// Get description and add it to share URL
						text = section.find(".subpage__header:first p").text().trim();

						if (text.length > maxChars) {
							text = text.substring(0, maxChars - 3) + "...";
						}

					} else {
						// Get title
						text = section.find("h1:first").text().trim();
					}

					shareUrl += "&text=" + encodeURIComponent(text + " ");

					// Get link and add it to share URL (with anchor if it exists - it really ought to)
					link = window.location.href + (anchor ? "#" + anchor : "");
					shareUrl += encodeURIComponent(link);
					eventHandlers.openPopup(shareUrl);
				});


				// Share on LinkedIn
				//------------------
				dom.linkedin.click(function (e) {
					e.preventDefault();

					var clicked = $(this),
						section = clicked.closest("section, .article__box--quote"),
						anchor,
						link,
						title,
						summary,
						shareUrl = "https://www.linkedin.com/shareArticle?mini=true";

					if (section.hasClass("figure-box")) {
						// Get data if figure box
						//-----------------------

						// Get anchor
						anchor = section.attr("id");

						// Get title and add it to share URL
						title = section.find("h1:first").text().trim();
						shareUrl += "&title=" + encodeURIComponent(title);

						// Get description and add it to share URL
						summary = section.find("article:first").text().trim();
						shareUrl += "&summary=" + encodeURIComponent(summary);
					} else if (section.hasClass("article__box--quote") || section.hasClass("box-quote")) {
						// Get data if quote box
						//----------------------

						// Get anchor
						anchor = section.attr("id");

						// Get title and add it to share URL
						title = section.find("figcaption > b:first").text().trim();
						shareUrl += "&title=" + encodeURIComponent(title);

						// Get description and add it to share URL
						summary = section.find("blockquote:first").text().trim();
						shareUrl += "&summary=" + encodeURIComponent(summary);
					} else if (section.hasClass("subpage article")) {
					// Get data if subpage article
					//-----------------------

					// Get anchor
					anchor = section.attr("id");

					title = section.find("h1:first").text().trim();
					shareUrl += "&title=" + encodeURIComponent(title);

					// Get description and add it to share URL
					summary = section.find(".subpage__header:first p").text().trim();
					shareUrl += "&summary=" + encodeURIComponent(summary);

					}

					// Get link and add it to share URL (with anchor if it exists - it really ought to)
					link = window.location.href + (anchor ? "#" + anchor : "");
					shareUrl += "&url=" + encodeURIComponent(link);

					eventHandlers.openPopup(shareUrl);
				});


				// Share on Facebook
				//------------------
				dom.facebook.click(function (e) {
					e.preventDefault();
					window.loadFB();
					var that = this;

					window.fbLoaded.promise.then(function() {
						var clicked = $(that),
							section = clicked.closest("section, .article__box--quote"),
							anchor,
							link,
							name,
							description,
							picture;
							//shareUrl = "https://www.facebook.com/dialog/feed?app_id=" + configuration.fbAppId + "&display=popup&locale=da_DK";

						if (section.hasClass("figure-box")) {
							// Get data if figure box
							//-----------------------

							// Get anchor
							anchor = section.attr("id");

							// Get title and add it to share URL
							name = section.find("h1:first").text().trim();
							//shareUrl += "&name=" + encodeURIComponent(name);

							// Get description and add it to share URL
							description = section.find("article:first").text().trim();
							//shareUrl += "&description=" + encodeURIComponent(description);

							// Get absolute path to picture and add it to share URL
							picture = section.find("figure img");
							if (picture.length) {
								picture = section.find("figure img")[0].src;
								//shareUrl += "&picture=" + encodeURIComponent(picture);
							}
						} else if (section.hasClass("article__box--quote") || section.hasClass("box-quote")) {
							// Get data if quote box
							//----------------------

							// Get anchor
							anchor = section.attr("id");

							// Get title and add it to share URL
							name = section.find("figcaption:first > b:first").text().trim().replace(/,\s*$/, "");
							//shareUrl += "&name=" + encodeURIComponent(name);

							// Get description and add it to share URL
							description = section.find("blockquote:first").text().trim();
							//shareUrl += "&description=" + encodeURIComponent(description);

							// Get absolute path to picture and add it to share URL
							picture = section.find("figure img");
							if (picture.length) {
								picture = section.find("figure img")[0].src;
								//shareUrl += "&picture=" + encodeURIComponent(picture);
							}
						} else if (section.hasClass("subpage article")) {
							// Get data if subpage article
							//-----------------------

							// Get anchor
							anchor = section.attr("id");

							// Get title and add it to share URL
							name = section.find("h1:first").text().trim();
							//shareUrl += "&name=" + encodeURIComponent(name);

							// Get description and add it to share URL
							description = section.find(".subpage__header:first p").text().trim();
							//shareUrl += "&description=" + encodeURIComponent(description);

							// Get absolute path to picture and add it to share URL
							// But not if it's from the aside box
							picture = section.find("aside:not('.article__box') figure img");
							if (picture.length) {
								picture = section.find("aside:not('.article__box') figure img")[0].src;
								//shareUrl += "&picture=" + encodeURIComponent(picture);
							}
						} else if (section.hasClass("subpage contactperson")) {
							// Get data if subpage contact person
							//-----------------------

							// Get anchor
							anchor = section.attr("id");

							// Get title and add it to share URL
							name = section.find("h1:first").text().trim();

							// Get description and add it to share URL
							description = section.find(".contactperson__info__details__row[itemprop='jobTitle']").text().trim();

							// Get absolute path to picture and add it to share URL
							// But not if it's from the aside box
							picture = section.find(".contactperson__info figure img");
							if (picture.length) {
								picture = section.find(".contactperson__info figure img")[0].src;
							}
						}

						// Get link and add it to share URL (with anchor if it exists - it really ought to)
						link = window.location.href + (anchor && anchor.indexOf("#") > -1 ? anchor : "#" + anchor);
						//shareUrl += "&link=" + encodeURIComponent(link);

						let fbObject = {
							'og:url': link,
							'og:title': name,
							'og:description': description,
						};

						// Use og:title and og:description if no case is matched
						if (fbObject["og:title"] === undefined) {
							fbObject["og:title"] = document.querySelector("meta[property='og:title']").getAttribute("content");
						}

						if (fbObject["og:description"] === undefined) {
							fbObject["og:description"] = document.querySelector("meta[property='og:description']").getAttribute("content");
						}

						if (picture && picture.length) {
							fbObject['og:image'] = picture.length === 0 ? "" : picture;
						}

						/* jshint ignore:start */
						// Open FB share popup
						window.FB.ui({
								method: 'share_open_graph',
								action_type: 'og.shares',
								action_properties: JSON.stringify({
									object: fbObject
								})
							},
							function () {
								// Action after response
							});

						//eventHandlers.openPopup(shareUrl);
						/* jshint ignore:end */
					});
				});
			}
		}

		selfScope.onReady(init);
	};

	dis.SocialSharing.prototype = new dis.BaseModule();
	dis.SocialSharing.constructor = dis.SocialSharing;


// This is where you define the global parameters you pass into your closure. You'll want to pass in any
// big stuff you'll need inside your script. Minor stuff can always be accessed through window.someVariable.
}(jQuery, dis));